<template>
  <b-card no-body>
    <b-overlay :show="loading_analyte_ranges" class="animated">
      <b-card-body>

        <b-row class="mb-3 font-weight-bolder">
          <b-col md="2">Analyte</b-col>
          <b-col>Irrigated</b-col>
          <b-col md="2">Very Low</b-col>
          <b-col md="2">Low</b-col>
          <b-col md="2">High</b-col>
          <b-col md="1"></b-col>
        </b-row>

        <template v-if="analyte_ranges && analyte_ranges.length">
          <AnalyteRangeFormRow
            v-for="(item, index) in analyte_ranges"
            :key="'range' + index"
            :index="index"
            :item="item"
            :fields="[
              { name: 'analyte_id', md: 2 },
              { name: 'irrigated' },
              { name: 'very_low', md: 2 },
              { name: 'low', md: 2 },
              { name: 'high', md: 2 }
            ]"
            class="mb-2 py-2 align-items-center"
            @refresh="$emit('refresh')"
          >
            <template #field(analyte_id)="{ row }">
              {{ row.analyte.name }}
            </template>

            <template #field(irrigated)="{ row }">
              <b-form-checkbox
                v-model="row.irrigated"
                :value="1"
                :unchecked-value="0"
              >
                Irrigated?
              </b-form-checkbox>
            </template>

            <template #field(very_low)="{ row }">
              <b-form-input
                v-model="row.very_low"
                type="text"
                placeholder="Very Low"
              />
            </template>

            <template #field(low)="{ row }">
              <b-form-input
                v-model="row.low"
                type="text"
                placeholder="Low"
              />
            </template>

            <template #field(high)="{ row }">
              <b-form-input
                v-model="row.high"
                type="text"
                placeholder="High"
              />
            </template>
          </AnalyteRangeFormRow>
        </template>

        <b-row v-else class="py-2 align-items-center bg-light">
          <b-col>
            <div class="text-center text-muted">
              No Analyte Ranges Found
            </div>
          </b-col>
        </b-row>

      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import AnalyteRangeFormRow from './AnalyteRangeFormRow.vue'

export default {
  name: 'AnalyteRangeFormSoilEdit',
  components: {
    AnalyteRangeFormRow
  },
  props: {
    analyte_ranges: {
      type: Array,
      default: () => []
    },
    loading_analyte_ranges: {
      type: Boolean,
      default: true
    }
  }
}
</script>
